import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./app/router.js";
import { AuthProvider } from "./features/auth/AuthProvider.js";

export function App(): JSX.Element {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
